import meteoraMark from "@shared/assets/icons/color/meteora.svg";
import orcaMark from "@shared/assets/icons/color/orca.svg";
import raydiumMark from "@shared/assets/icons/color/raydium.svg";
import React from "react";

/**
 * Per-provider logomark for venue rows.
 *
 * These are the **colour** marks (`assets/icons/color/`), not the
 * grayscale set used by the position breakdown rows. The distinction is
 * deliberate: a breakdown row is subordinate to the balance beside it,
 * so its mark stays grey; a venue directory is where provider identity
 * is the point, so the mark carries the protocol's own colour.
 *
 * One entry per integrated provider, no generic placeholder — an
 * unmapped provider renders a neutral outline rather than borrowing
 * another protocol's mark, so a missing logo is visibly missing.
 */
const PROVIDER_MARKS: Record<string, string> = {
    Meteora: meteoraMark,
    Orca: orcaMark,
    Raydium: raydiumMark
};

export function venueIconFor(
    provider: string,
    className = "size-12 shrink-0"
): React.ReactNode {
    const src = PROVIDER_MARKS[provider];
    if (!src) {
        return (
            <div
                className={`${className} rounded-full border border-line-neutral`}
                aria-hidden
            />
        );
    }
    return (
        <img
            src={src}
            alt=""
            aria-hidden
            className={`${className} object-contain`}
        />
    );
}
